import {FETCH_COMPANIES_REQUEST, FETCH_COMPANIES_SUCCES, FETCH_COMPANIES_ERROR} from '../constants/Companies'
import { jsonGet, errorHandler } from '../utils/Request';
import getFilterParameters from '../utils/getFilterParameters';

const loadCompanies = (filter) => (dispatch) => {
  const parameters = getFilterParameters(filter, 'company');
  const apiUrl = `/company/list/${parameters ? parameters : '' }`;
  dispatch({
    type: FETCH_COMPANIES_REQUEST,
  });
  return jsonGet(apiUrl)
    .then(json => {
      dispatch({
        type: FETCH_COMPANIES_SUCCES,
        payload: json,
      });
    })
    .catch((e) => {
      dispatch({
        type: FETCH_COMPANIES_ERROR
      });
      errorHandler(e);
    });
};

export { loadCompanies };



// WEBPACK FOOTER //
// ./src/actions/CompaniesActions.js